import useFetch from 'utils/hooks/useFetch'
import { ApiGetBankBalanceList, ApiUpdateBankBalance } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function BankBalanceService() {
    const { showFail } = useModal()

    const { fetch: apiGetBankBalance } = useFetch(ApiGetBankBalanceList)
    const { fetch: apiUpdateBankBalance } = useFetch(ApiUpdateBankBalance)
 
    const fetchBankBalance = async () => {
        const res = await apiGetBankBalance({
            data: { }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateBankBalance = async (transferSourceId, beneficiaryId, bankBalanceId, balance) => {
        const res = await apiUpdateBankBalance({
            data: { 
                transferSourceId,
                beneficiaryId, 
                bankBalanceId, 
                balance
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchBankBalance,
        fetchUpdateBankBalance
    }
}